export default "__VITE_ASSET__4307fb6d__"